import React, { useState } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { withDropdownFont } from "components/reactSelect/dropdownFontStyles";

const SearchableSelectLazy = ({
    className,
    classNamePrefix,
    name,
    options,
    isMulti,
    isDisabled = false,
    isLoading = false,
    isClearable = true,
    isRtl = false,
    isSearchable = true,
    fontSize,
    width = "100%",
    defaultValue = null,
    onChange,
    onInputChange,
    ...rest // 👈 THIS IS THE KEY
}) => {
    const [inputValue, setInputValue] = useState("");

    const handleInputChange = (newValue) => {
        setInputValue(newValue);
        if (onInputChange) {
            onInputChange(newValue);
        }
    };

    return (
        <Select
            {...rest}   // 👈 ALL EVENTS (onFocus, onMenuOpen, etc) FORWARDED
            className={className}
            classNamePrefix={classNamePrefix}
            closeMenuOnSelect={false}
            isDisabled={isDisabled}
            isLoading={isLoading}
            isClearable={isClearable}
            isRtl={isRtl}
            isSearchable={isSearchable}
            name={name}
            options={options}
            isMulti={isMulti}
            menuPortalTarget={document.body}
            defaultValue={defaultValue}
            onChange={onChange}
            onInputChange={handleInputChange}
            inputValue={inputValue}
            styles={{
                container: (provided) => withDropdownFont({
                    ...provided,
                    width: width,
                    height: "20px",
                    fontSize: fontSize,
                }),
                menu: (provided) => withDropdownFont({
                    ...provided,
                    width: width,
                    fontSize: fontSize,
                }),
                menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                }),
                dropdownIndicator: (provided) => ({
                    ...provided,
                    display: "none",
                }),
                control: (provided) => withDropdownFont({
                    ...provided,
                    fontSize: fontSize,
                }),
                singleValue: (provided) => withDropdownFont({
                    ...provided,
                    fontSize: fontSize,
                }),
                placeholder: (provided) => withDropdownFont({
                    ...provided,
                    fontSize: fontSize,
                }),
                option: (provided) => withDropdownFont({
                    ...provided,
                    fontSize: fontSize,
                }),
            }}
        />
    );
};

SearchableSelectLazy.propTypes = {
    className: PropTypes.string.isRequired,
    classNamePrefix: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    isMulti: PropTypes.bool.isRequired,
    isDisabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    isClearable: PropTypes.bool,
    isRtl: PropTypes.bool,
    isSearchable: PropTypes.bool,
    fontSize: PropTypes.string,
    width: PropTypes.string,
    onChange: PropTypes.func,
    onInputChange: PropTypes.func,
    defaultValue: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]),
};

export default SearchableSelectLazy;
